const hnadleTextToggle = () => {
	const $toggler = $('.js-toggle-text');

	$toggler.on('click', function(event) {
		event.preventDefault();

		const $this = $(this);
		$this.parent().toggleClass('is-active');

		handleToggle($this);
	});

	$(window).on('load', function() {
		const $toggler = $('.js-toggle-text');

		$toggler.each(function(index, el) {
			const $this = $(this);

			handleToggle($this);
		});
	});

	const handleToggle = ($this) => {
		const showLess = $this.data('less');
		const showMore = $this.data('more');

		$this.parent().hasClass('is-active') ? $this.text(showLess) : $this.text(showMore);
	};
};

hnadleTextToggle();
